// @ts-ignore
module.exports = {
  globalVariable: {
    gateway: '/gateway/',
    domain: 'http://106.14.107.123:8081',
    service_url: 'https://prod-crm.oss-cn-beijing.aliyuncs.com/',
    h5_url: 'https://campaign-k8s.itrigger.accenture.cn/',
    wx_url: '/wx_url/',
    socketKey: 'BC-7e50e66e7d394c12a7747b65a2ac692a',
    socketUrl: 'wss://ac-crm.accioe.store/websocket',
    useGoEasy: false
  }
}
